var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26C0 11.6402 11.6402 0 26 0C40.3598 0 52 11.6402 52 26C52 40.3598 40.3598 52 26 52C11.6402 52 0 40.3598 0 26ZM22.6383 38.2382L40.8383 20.0382C41.8549 19.0216 41.8549 17.3784 40.8383 16.3618C39.8217 15.3452 38.1785 15.3452 37.1619 16.3618L20.8001 32.7236L14.8383 26.7618C13.8217 25.7452 12.1785 25.7452 11.1619 26.7618C10.1453 27.7784 10.1453 29.4216 11.1619 30.4382L18.9619 38.2382C19.4689 38.7452 20.1345 39 20.8001 39C21.4657 39 22.1313 38.7452 22.6383 38.2382Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSvg);
export default __webpack_public_path__ + "static/media/Tick-svg.e495fac34698af5342492fce014bee63.svg";
export { ForwardRef as ReactComponent };